import { createBrowserClient } from "@supabase/ssr";

const isDev = process.env.NODE_ENV === "development";
const appEnv = process.env.NEXT_PUBLIC_APP_ENV || "development";
const isPreprod = appEnv === "preprod";

let currentDomain: string;
if (isDev) {
  currentDomain = process.env.NEXT_PUBLIC_LOCAL_DOMAIN || "localhost:3000";
} else if (isPreprod) {
  currentDomain = process.env.NEXT_PUBLIC_DEV_DOMAIN || "renwu.dev";
} else {
  currentDomain = process.env.NEXT_PUBLIC_ROOT_DOMAIN || "renwu.app";
}

export function createClient() {
  return createBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
    {
      cookieOptions: {
        ...(isDev ? {} : { domain: `.${currentDomain}` }),
        maxAge: 60 * 60 * 24 * 30, // 30 days
        path: "/",
        sameSite: "lax",
        secure: !isDev,
      },
      auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true,
      },
    }
  );
}
